"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _InlineResponse = _interopRequireDefault(require("../model/InlineResponse200"));

var _PasswordChange = _interopRequireDefault(require("../model/PasswordChange"));

var _PasswordResetConfirm = _interopRequireDefault(require("../model/PasswordResetConfirm"));

var _Token = _interopRequireDefault(require("../model/Token"));

var _UserDetails = _interopRequireDefault(require("../model/UserDetails"));

var _UserLogin = _interopRequireDefault(require("../model/UserLogin"));

var _UserPasswordReset = _interopRequireDefault(require("../model/UserPasswordReset"));

var _UserRegister = _interopRequireDefault(require("../model/UserRegister"));

var _VerifyEmail = _interopRequireDefault(require("../model/VerifyEmail"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
* RestAuth service.
* @module api/RestAuthApi
* @version 1.0.9
*/
var RestAuthApi = /*#__PURE__*/function () {
  /**
  * Constructs a new RestAuthApi. 
  * @alias module:api/RestAuthApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function RestAuthApi(apiClient) {
    _classCallCheck(this, RestAuthApi);

    this.apiClient = apiClient || _ApiClient.default.instance;
  }
  /**
   * @param {String} key 
   * @param {module:model/VerifyEmail} data 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/VerifyEmail} and HTTP response
   */


  _createClass(RestAuthApi, [{
    key: "restAuthAccountConfirmEmailCreateWithHttpInfo",
    value: function restAuthAccountConfirmEmailCreateWithHttpInfo(key, data) {
      var postBody = data; // verify the required parameter 'key' is set

      if (key === undefined || key === null) {
        throw new Error("Missing the required parameter 'key' when calling restAuthAccountConfirmEmailCreate");
      } // verify the required parameter 'data' is set


      if (data === undefined || data === null) {
        throw new Error("Missing the required parameter 'data' when calling restAuthAccountConfirmEmailCreate");
      }

      var pathParams = {
        'key': key
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['api_key'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _VerifyEmail.default;
      return this.apiClient.callApi('/rest-auth/account-confirm-email/{key}/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * @param {String} key 
     * @param {module:model/VerifyEmail} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/VerifyEmail}
     */

  }, {
    key: "restAuthAccountConfirmEmailCreate",
    value: function restAuthAccountConfirmEmailCreate(key, data) {
      return this.restAuthAccountConfirmEmailCreateWithHttpInfo(key, data).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Check the credentials and return the REST Token if the credentials are valid and authenticated. Calls Django Auth login method to register User ID in Django session framework  Accept the following POST parameters: username, password Return the REST Framework Token Object's key.
     * @param {module:model/UserLogin} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Token} and HTTP response
     */

  }, {
    key: "restAuthLoginCreateWithHttpInfo",
    value: function restAuthLoginCreateWithHttpInfo(data) {
      var postBody = data; // verify the required parameter 'data' is set

      if (data === undefined || data === null) {
        throw new Error("Missing the required parameter 'data' when calling restAuthLoginCreate");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['api_key'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _Token.default;
      return this.apiClient.callApi('/rest-auth/login/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Check the credentials and return the REST Token if the credentials are valid and authenticated. Calls Django Auth login method to register User ID in Django session framework  Accept the following POST parameters: username, password Return the REST Framework Token Object's key.
     * @param {module:model/UserLogin} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Token}
     */

  }, {
    key: "restAuthLoginCreate",
    value: function restAuthLoginCreate(data) {
      return this.restAuthLoginCreateWithHttpInfo(data).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Calls Django logout method and delete the Token object assigned to the current User object.
     * Accepts/Returns nothing.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "restAuthLogoutCreateWithHttpInfo",
    value: function restAuthLogoutCreateWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['api_key'];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/rest-auth/logout/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Calls Django logout method and delete the Token object assigned to the current User object.
     * Accepts/Returns nothing.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "restAuthLogoutCreate",
    value: function restAuthLogoutCreate() {
      return this.restAuthLogoutCreateWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Calls Django logout method and delete the Token object assigned to the current User object.
     * Accepts/Returns nothing.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "restAuthLogoutListWithHttpInfo",
    value: function restAuthLogoutListWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['api_key'];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/rest-auth/logout/', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Calls Django logout method and delete the Token object assigned to the current User object.
     * Accepts/Returns nothing.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "restAuthLogoutList",
    value: function restAuthLogoutList() {
      return this.restAuthLogoutListWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Calls Django Auth SetPasswordForm save method.
     * Accepts the following POST parameters: new_password1, new_password2 Returns the success/fail message.
     * @param {module:model/PasswordChange} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InlineResponse200} and HTTP response
     */

  }, {
    key: "restAuthPasswordChangeCreateWithHttpInfo",
    value: function restAuthPasswordChangeCreateWithHttpInfo(data) {
      var postBody = data; // verify the required parameter 'data' is set

      if (data === undefined || data === null) {
        throw new Error("Missing the required parameter 'data' when calling restAuthPasswordChangeCreate");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['api_key'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _InlineResponse.default;
      return this.apiClient.callApi('/rest-auth/password/change/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Calls Django Auth SetPasswordForm save method.
     * Accepts the following POST parameters: new_password1, new_password2 Returns the success/fail message.
     * @param {module:model/PasswordChange} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InlineResponse200}
     */

  }, {
    key: "restAuthPasswordChangeCreate",
    value: function restAuthPasswordChangeCreate(data) {
      return this.restAuthPasswordChangeCreateWithHttpInfo(data).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Password reset e-mail link is confirmed, therefore this resets the user's password.
     * Accepts the following POST parameters: token, uid,     new_password1, new_password2 Returns the success/fail message.
     * @param {module:model/PasswordResetConfirm} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/PasswordResetConfirm} and HTTP response
     */

  }, {
    key: "restAuthPasswordResetConfirmCreateWithHttpInfo",
    value: function restAuthPasswordResetConfirmCreateWithHttpInfo(data) {
      var postBody = data; // verify the required parameter 'data' is set

      if (data === undefined || data === null) {
        throw new Error("Missing the required parameter 'data' when calling restAuthPasswordResetConfirmCreate");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['api_key'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _PasswordResetConfirm.default;
      return this.apiClient.callApi('/rest-auth/password/reset/confirm/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Password reset e-mail link is confirmed, therefore this resets the user's password.
     * Accepts the following POST parameters: token, uid,     new_password1, new_password2 Returns the success/fail message.
     * @param {module:model/PasswordResetConfirm} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/PasswordResetConfirm}
     */

  }, {
    key: "restAuthPasswordResetConfirmCreate",
    value: function restAuthPasswordResetConfirmCreate(data) {
      return this.restAuthPasswordResetConfirmCreateWithHttpInfo(data).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Calls Django Auth PasswordResetForm save method.
     * Accepts the following POST parameters: email Returns the success/fail message.
     * @param {module:model/UserPasswordReset} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/UserPasswordReset} and HTTP response
     */

  }, {
    key: "restAuthPasswordResetCreateWithHttpInfo",
    value: function restAuthPasswordResetCreateWithHttpInfo(data) {
      var postBody = data; // verify the required parameter 'data' is set

      if (data === undefined || data === null) {
        throw new Error("Missing the required parameter 'data' when calling restAuthPasswordResetCreate");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['api_key'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _UserPasswordReset.default;
      return this.apiClient.callApi('/rest-auth/password/reset/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Calls Django Auth PasswordResetForm save method.
     * Accepts the following POST parameters: email Returns the success/fail message.
     * @param {module:model/UserPasswordReset} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/UserPasswordReset}
     */

  }, {
    key: "restAuthPasswordResetCreate",
    value: function restAuthPasswordResetCreate(data) {
      return this.restAuthPasswordResetCreateWithHttpInfo(data).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * @param {module:model/UserRegister} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InlineResponse200} and HTTP response
     */

  }, {
    key: "restAuthRegistrationCreateWithHttpInfo",
    value: function restAuthRegistrationCreateWithHttpInfo(data) {
      var postBody = data; // verify the required parameter 'data' is set

      if (data === undefined || data === null) {
        throw new Error("Missing the required parameter 'data' when calling restAuthRegistrationCreate");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['api_key'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _InlineResponse.default;
      return this.apiClient.callApi('/rest-auth/registration/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * @param {module:model/UserRegister} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InlineResponse200}
     */

  }, {
    key: "restAuthRegistrationCreate",
    value: function restAuthRegistrationCreate(data) {
      return this.restAuthRegistrationCreateWithHttpInfo(data).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * @param {module:model/VerifyEmail} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/VerifyEmail} and HTTP response
     */

  }, {
    key: "restAuthRegistrationVerifyEmailCreateWithHttpInfo",
    value: function restAuthRegistrationVerifyEmailCreateWithHttpInfo(data) {
      var postBody = data; // verify the required parameter 'data' is set

      if (data === undefined || data === null) {
        throw new Error("Missing the required parameter 'data' when calling restAuthRegistrationVerifyEmailCreate");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['api_key'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _VerifyEmail.default;
      return this.apiClient.callApi('/rest-auth/registration/verify-email/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * @param {module:model/VerifyEmail} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/VerifyEmail}
     */

  }, {
    key: "restAuthRegistrationVerifyEmailCreate",
    value: function restAuthRegistrationVerifyEmailCreate(data) {
      return this.restAuthRegistrationVerifyEmailCreateWithHttpInfo(data).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Reads and updates UserModel fields Accepts GET, PUT, PATCH methods.
     * Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email  Returns UserModel fields.
     * @param {module:model/UserDetails} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/UserDetails} and HTTP response
     */

  }, {
    key: "restAuthUserPartialUpdateWithHttpInfo",
    value: function restAuthUserPartialUpdateWithHttpInfo(data) {
      var postBody = data; // verify the required parameter 'data' is set

      if (data === undefined || data === null) {
        throw new Error("Missing the required parameter 'data' when calling restAuthUserPartialUpdate");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['api_key'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _UserDetails.default;
      return this.apiClient.callApi('/rest-auth/user/', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Reads and updates UserModel fields Accepts GET, PUT, PATCH methods.
     * Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email  Returns UserModel fields.
     * @param {module:model/UserDetails} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/UserDetails}
     */

  }, {
    key: "restAuthUserPartialUpdate",
    value: function restAuthUserPartialUpdate(data) {
      return this.restAuthUserPartialUpdateWithHttpInfo(data).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Reads and updates UserModel fields Accepts GET, PUT, PATCH methods.
     * Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email  Returns UserModel fields.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/UserDetails} and HTTP response
     */

  }, {
    key: "restAuthUserReadWithHttpInfo",
    value: function restAuthUserReadWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['api_key'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _UserDetails.default;
      return this.apiClient.callApi('/rest-auth/user/', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Reads and updates UserModel fields Accepts GET, PUT, PATCH methods.
     * Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email  Returns UserModel fields.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/UserDetails}
     */

  }, {
    key: "restAuthUserRead",
    value: function restAuthUserRead() {
      return this.restAuthUserReadWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Reads and updates UserModel fields Accepts GET, PUT, PATCH methods.
     * Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email  Returns UserModel fields.
     * @param {module:model/UserDetails} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/UserDetails} and HTTP response
     */

  }, {
    key: "restAuthUserUpdateWithHttpInfo",
    value: function restAuthUserUpdateWithHttpInfo(data) {
      var postBody = data; // verify the required parameter 'data' is set

      if (data === undefined || data === null) {
        throw new Error("Missing the required parameter 'data' when calling restAuthUserUpdate");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['api_key'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _UserDetails.default;
      return this.apiClient.callApi('/rest-auth/user/', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Reads and updates UserModel fields Accepts GET, PUT, PATCH methods.
     * Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email  Returns UserModel fields.
     * @param {module:model/UserDetails} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/UserDetails}
     */

  }, {
    key: "restAuthUserUpdate",
    value: function restAuthUserUpdate(data) {
      return this.restAuthUserUpdateWithHttpInfo(data).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);

  return RestAuthApi;
}();

exports.default = RestAuthApi;